(function () {
  const root = document.querySelector('[data-fashion-trends]')
  if (!root) return

  const sectionKey = root.getAttribute('data-fashion-trends-section-key')
  const gridWrap = root.querySelector('.fashion-trends__grid-wrap')
  let currentMode = 'trending'

  function num (el, attr) {
    const v = parseInt(el.getAttribute(attr), 10)
    return Number.isFinite(v) ? v : 0
  }

  function sortKey (mode) {
    return function (a, b) {
      if (mode === 'trending') {
        return num(a, 'data-original-index') - num(b, 'data-original-index')
      }
      if (mode === 'newest') {
        return num(b, 'data-published') - num(a, 'data-published')
      }
      if (mode === 'popular') {
        const diff = num(b, 'data-comments') - num(a, 'data-comments')
        if (diff !== 0) return diff
        return num(b, 'data-published') - num(a, 'data-published')
      }
      if (mode === 'editor') {
        const ed = num(b, 'data-editor') - num(a, 'data-editor')
        if (ed !== 0) return ed
        return num(b, 'data-published') - num(a, 'data-published')
      }
      return 0
    }
  }

  function applySort () {
    const grid = root.querySelector('[data-fashion-trends-grid]')
    if (!grid) return
    const moduleEl = grid.querySelector('[data-fashion-trends-collection]')
    const cards = Array.from(grid.querySelectorAll('[data-fashion-trends-card]'))
    if (cards.length === 0) return
    const sorted = cards.slice().sort(sortKey(currentMode))
    const mid = Math.floor(sorted.length / 2)

    if (moduleEl && sorted.length >= 2) {
      sorted.slice(0, mid).forEach(function (node) {
        grid.appendChild(node)
      })
      grid.appendChild(moduleEl)
      sorted.slice(mid).forEach(function (node) {
        grid.appendChild(node)
      })
    } else {
      sorted.forEach(function (node) {
        grid.appendChild(node)
      })
    }
  }

  function initFilter () {
    const filterRoot = root.querySelector('[data-fashion-trends-filter]')
    if (!filterRoot) return

    const trigger = filterRoot.querySelector('.fashion-trends__filter-trigger')
    const list = filterRoot.querySelector('[data-fashion-trends-filter-list]')
    const labelEl = filterRoot.querySelector('[data-fashion-trends-filter-label]')
    const options = Array.from(filterRoot.querySelectorAll('[data-value]'))

    if (!trigger || !list || !labelEl || options.length === 0) return

    function setSelectedOption (mode) {
      options.forEach(function (opt) {
        const isSel = opt.getAttribute('data-value') === mode
        opt.setAttribute('aria-selected', isSel ? 'true' : 'false')
        opt.classList.toggle('fashion-trends__filter-option--selected', isSel)
      })
      const active = options.find(function (o) {
        return o.getAttribute('data-value') === mode
      })
      if (active && labelEl) {
        const text = active.querySelector('.fashion-trends__filter-option-text')
        if (text) labelEl.textContent = text.textContent
      }
    }

    function closeList () {
      list.hidden = true
      trigger.setAttribute('aria-expanded', 'false')
      filterRoot.classList.remove('fashion-trends__sort-row--open')
    }

    function openList () {
      list.hidden = false
      trigger.setAttribute('aria-expanded', 'true')
      filterRoot.classList.add('fashion-trends__sort-row--open')
    }

    function toggleList () {
      if (list.hidden) openList()
      else closeList()
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation()
      toggleList()
    })

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation()
        const mode = opt.getAttribute('data-value')
        if (!mode || mode === currentMode) {
          closeList()
          return
        }
        currentMode = mode
        setSelectedOption(mode)
        applySort()
        closeList()
      })
    })

    document.addEventListener('click', function (e) {
      if (!filterRoot.contains(e.target)) closeList()
    })

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !list.hidden) {
        closeList()
      }
    })

    setSelectedOption('trending')
    applySort()
  }

  /**
   * Section Rendering API: use `section_id` (not `sections`) so the response is
   * raw HTML — avoids JSON key mismatches with `sections` (null → catch → full reload).
   * @see https://shopify.dev/docs/api/ajax/section-rendering
   */
  function fetchSectionHtml (pageUrl) {
    if (!sectionKey || !gridWrap) return Promise.reject(new Error('missing section key or grid wrap'))

    const u = new URL(pageUrl, window.location.origin)
    u.hash = ''
    u.searchParams.set('section_id', sectionKey)

    return fetch(u.toString(), {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (res) {
      if (!res.ok) throw new Error('section fetch failed')
      return res.text()
    })
  }

  function replaceGridFromHtml (htmlString) {
    if (!gridWrap || typeof htmlString !== 'string' || htmlString.length === 0) return false

    const doc = new DOMParser().parseFromString(htmlString, 'text/html')
    const newWrap = doc.querySelector('.fashion-trends__grid-wrap')
    if (!newWrap) return false

    gridWrap.innerHTML = newWrap.innerHTML
    return true
  }

  function scrollSectionIntoView () {
    root.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  function loadPage (pageUrl, pushHistory) {
    const nav = root.querySelector('[data-fashion-trends-pagination]')
    if (nav) nav.classList.add('fashion-trends__pagination--loading')

    fetchSectionHtml(pageUrl)
      .then(function (html) {
        if (!replaceGridFromHtml(html)) throw new Error('parse failed')
        if (pushHistory) {
          const clean = new URL(pageUrl, window.location.origin)
          history.pushState({ fashionTrendsAjax: true }, '', clean.pathname + clean.search + clean.hash)
        }
        applySort()
        scrollSectionIntoView()
      })
      .catch(function () {
        window.location.assign(pageUrl)
      })
      .finally(function () {
        const n = root.querySelector('[data-fashion-trends-pagination]')
        if (n) n.classList.remove('fashion-trends__pagination--loading')
      })
  }

  function initPaginationAjax () {
    if (!sectionKey || !gridWrap) return

    const pagePathname = window.location.pathname

    root.addEventListener('click', function (e) {
      const a = e.target.closest('a')
      if (!a || !a.closest('[data-fashion-trends-pagination]')) return

      const href = a.getAttribute('href')
      if (!href || href.charAt(0) === '#') return

      const target = new URL(href, window.location.origin)
      if (target.origin !== window.location.origin) return

      e.preventDefault()
      loadPage(href, true)
    })

    window.addEventListener('popstate', function () {
      if (!gridWrap || window.location.pathname !== pagePathname) return
      loadPage(window.location.href, false)
    })
  }

  initPaginationAjax()
  initFilter()
})()
